window.jQuery = window.$ = require('jquery');
window.Hammer = require('hammerjs');
window.ko = require('knockout');
window.ko.mapping = require('knockout.mapping');
require('./features/jquery.history.js');
require('./features/utils');
require('./features/tabs');
require('./features/sub-nav-tabs');
require('./features/load-more');
require('./features/ajax');
require('devbridge-autocomplete');
require('jquery-ajax-unobtrusive');
window._ = require('underscore');